<template>
<figure class="image is-24x24">
    <img
        class="is-rounded"
        :src="getLink"
    />
</figure>
</template>

<script>
import md5 from 'md5';

export default {
    computed: {
        getLink() {
            const email = this.$store.state.profile.email || '';
            const hash = md5(email);
            return `https://www.gravatar.com/avatar/${hash}?d=mp`;
        }
    },
};
</script>
